export enum UtilType {
	NEW = 'new',
	EDIT = 'edit',
    VIEW = 'view'
}


export enum SCAMBIO {
    SEMPLICE = 'SS',
    DOPPIO = 'SD',
    INTERSEZIONE = 'SI'
}